/** Lista padrão de Credit/Banking/Billing (`GetListApiResponseSuccess` do legado). */
export interface PagedResponse<T> {
  data: T[];
  page: number;
  paginationToken?: string | null;
  totalItems: number;
  totalPages: number;
}

/** Lista da SearchApi (`GetListApiElasticSearch`): atenção a `totalPage`, no singular. */
export interface SearchPagedResponse<T, M = unknown> {
  data: T[];
  page: number;
  totalItems: number;
  totalPage: number;
  metadata: M;
}

/** Estado de paginação da tela: índice a partir de 0 e tamanho. */
export interface PageState {
  pageIndex: number;
  pageSize: number;
}

/** Página normalizada para `DataView`, venha de qual API vier. */
export interface Page<T> {
  items: T[];
  total: number;
  pageCount: number;
}

/** Query padrão do legado: `page` começa em 0, `size` é o tamanho. */
export function toPageParams({ pageIndex, pageSize }: PageState) {
  return { page: pageIndex, size: pageSize };
}

/** Query da SearchApi: `from` é deslocamento (página × tamanho), não número de página. */
export function toSearchParams({ pageIndex, pageSize }: PageState) {
  return { from: pageIndex * pageSize, size: pageSize };
}

export function fromPagedResponse<T>(response: PagedResponse<T>): Page<T> {
  return { items: response.data, total: response.totalItems, pageCount: response.totalPages };
}

export function fromSearchPagedResponse<T>(response: SearchPagedResponse<T>): Page<T> {
  return { items: response.data, total: response.totalItems, pageCount: response.totalPage };
}

export type SortDirection = 'asc' | 'desc';

/** `orderBy=<campo>_<ASC|DESC>`, como `createdAt_DESC`. */
export function toOrderBy(field: string, direction: SortDirection): string {
  return `${field}_${direction.toUpperCase()}`;
}

/** Inverso de `toOrderBy`; `undefined` se o valor não segue o formato. */
export function parseOrderBy(value: string | undefined): { field: string; direction: SortDirection } | undefined {
  const match = value ? /^(.+)_(ASC|DESC)$/i.exec(value) : null;
  if (!match?.[1] || !match[2]) return undefined;
  return { field: match[1], direction: match[2].toLowerCase() as SortDirection };
}

/** Tamanhos de página do legado; o padrão era 5 (`localStorage.rowsPerPage`). */
export const PAGE_SIZE_OPTIONS = [5, 10, 15, 20] as const;
export const DEFAULT_PAGE_SIZE = 5;
